/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject, Routes, Route } from 'react-router-dom';
import { SuppChainTransPage } from './navigation';
import { SidebarWidget } from '@widgets/sidebar-widget-react';
import { VApplication } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync('services.AppNavigatorService') as AppNavigatorService;
};

export const getSuppChainTransPageRoute = (props: any): RouteObject | any => {
  const srv = getAppNavService();
  return {
    path: '/transactions',
    element: (
      <SidebarWidget
        {...props}
        component={SuppChainTransPage}
      // abilityCheck={srv.abilityCheck.bind(
      //   null,
      //   props?.routes?.Profile?.id,
      //   props.whoami,
      //   'read'
      // )}
      />
    ),
  };
};
